import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Base_RequestMessageComposer } from '../../Page_BaseSandbox/Base_RequestMessageComposer/index.js';
import './Component_NLPRequestMessageComposer.scss';
import { ModuleFE_SandboxNLP } from '../../modules/ModuleFE_SandboxNLP/index.js';
import React from 'react';
import { Button, EditableItem, LL_H_C, LL_V_L, ModuleFE_Toaster, StorageKey, Thunder, TS_Card, TS_TextArea } from '@nu-art/thunderstorm-frontend/index';
import { __stringify, arrayIncludesAll, isValidJson, MUSTNeverHappenException } from '@nu-art/ts-common';
import { AdvisorTagMultiSelect, DropDown_NlpEnv } from '../ui-components.js';
import { DataGrid, ICONS } from '@app/styles';
import { ModuleFE_GladosInterface } from '../../../../modules/index.js';
import { resolveValueDisplay } from '@app/hcs-shared';
import { Q_VariablePanel } from '@app/hcs-frontend';
import { TS_Icons } from '@nu-art/ts-styles';
import { ModuleFE_Advisor_Value, ModuleFE_Advisor_Variable } from '../../../../modules/static-modules/healthcare-space.js';
import { defaultEHRId } from '../../../pages/NEW_Page_Demo/index.js';
import { ModuleFE_AdvisorSession } from '../../../../_entity/advisor-session/index.js';
import { ModuleFE_EMInterface } from '../../../../_entity/runtime/em-interface/index.js';
const storageKey_preferredEnv = new StorageKey('storage_nlpPreferredEnv');
export class Component_NLPRequestMessageComposer extends Base_RequestMessageComposer {
    // ######################### Life Cycle #########################
    static defaultProps = {
        module: ModuleFE_SandboxNLP,
    };
    __onTemplateSelected(template) {
        this.reDeriveState({
            selectedTemplate: template,
            templateString: undefined,
            findings: undefined
        });
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        // Auto save is true for now to make sure the entire thing updates on every change
        state.editable = new EditableItem(isValidJson(state.templateString) ? JSON.parse(state.templateString) : {})
            .setSaveAction(async (item) => {
            this.setState({ templateString: __stringify(item, true) });
            return item;
        }).setAutoSave(true);
        state.isStructured ??= true;
        if (!state.selectedTemplate)
            state.findings = undefined;
        // update default env
        if (!state.editable.get('env')) {
            const thunder = Thunder.getInstance();
            const envLabel = thunder.getConfig().label;
            state.editable.item.env = storageKey_preferredEnv.get(envLabel ? envLabel.toLowerCase() : 'prod');
        }
        return state;
    }
    // ######################### Logic #########################
    async sendRequest(template) {
        if (!isValidJson(template))
            ModuleFE_Toaster.toastError('Invalid context provided');
        const content = JSON.parse(template);
        ModuleFE_SandboxNLP.addMessageToHistory({ type: 'sent', content: content });
        const findings = await ModuleFE_EMInterface.vv1.sandbox.getNlpSandboxVariables({
            ehrInstanceId: ModuleFE_AdvisorSession.getCurrentEhrInstance(defaultEHRId),
            snippet: {
                text: content.text,
                rules: content.rules
            }
        }).executeSync();
        ModuleFE_SandboxNLP.addMessageToHistory({ type: 'received', content: findings });
        this.setState({ findings: findings.findings });
    }
    // ######################### Render - Structured View #########################
    renderHeaderTail = () => {
        return _jsxs(LL_H_C, { onClick: async () => await ModuleFE_GladosInterface.vv1.getGladosLogs({ env: this.state.editable.get('env') }).executeSync(), className: 'download-nlp-logs', children: [_jsx(TS_Icons.download.component, {}), "Download Glados Logs"] });
    };
    renderVariablePanel = () => {
        const rules = this.state.editable.get('rules');
        return _jsx(Q_VariablePanel, { filter: (item) => {
                if (!rules)
                    return false;
                return rules.some(rule => arrayIncludesAll(item._tagIds, rule.tagIds));
            }, module: ModuleFE_Advisor_Variable });
    };
    renderTagMultiselect = () => {
        const editableRules = this.state.editable.editProp('rules', []);
        return _jsxs(LL_V_L, { className: 'composer-body__section', children: [_jsx("div", { className: 'title', children: "Rules" }), _jsxs(LL_V_L, { className: 'composer-body__rules-list', children: [this.state.editable.get('rules').map((rule, index) => {
                            const editableRule = editableRules.editProp(index, { tagIds: [] });
                            return _jsxs(TS_Card, { className: 'composer-body__rule', children: [_jsxs(LL_H_C, { className: 'match_width flex__space-between', children: [_jsxs("div", { className: 'rule-title', children: ["Rule ", index + 1] }), _jsx(ICONS.x.component, { className: 'remove-rule', onClick: () => editableRules.removeArrayItem(index) })] }), _jsx(AdvisorTagMultiSelect, { editable: editableRule, prop: 'tagIds' })] }, index);
                        }), _jsx(Button, { onClick: () => editableRules.updateArrayAt({ tagIds: [] }), children: "Add Rule" })] })] });
    };
    renderFreeTextInput = () => {
        return _jsxs(LL_V_L, { className: 'composer-body__section', children: [_jsx("div", { className: 'title', children: "Free Text" }), _jsx(TS_TextArea, { type: 'text', value: this.state.editable.get('text'), onChange: value => this.state.editable.update('text', value.trim()) })] });
    };
    renderFindingsGrid = () => {
        if (!this.state.findings || !this.state.findings.length)
            return _jsx("div", { children: "No Findings Found" });
        return _jsx(DataGrid.Grid, { children: this.state.findings.map((finding, index) => {
                const variable = ModuleFE_Advisor_Variable.cache.unique(finding.variableId);
                const value = ModuleFE_Advisor_Value.cache.unique(finding.valueId);
                if (!variable)
                    throw new MUSTNeverHappenException(`Variable with id ${finding.variableId} not found`);
                if (!value)
                    throw new MUSTNeverHappenException(`Value with id ${finding.valueId} not found`);
                return _jsxs(React.Fragment, { children: [_jsx(DataGrid.Data, { children: variable.name }), _jsx(DataGrid.Data, { children: resolveValueDisplay(value) })] }, index);
            }) });
    };
    renderFindings = () => {
        return _jsxs(LL_V_L, { className: 'composer-body__section findings', children: [_jsx("div", { className: 'title', children: "NLP Findings" }), this.renderFindingsGrid()] });
    };
    renderEnvDropDown = () => {
        return _jsxs(LL_V_L, { className: 'composer-body__section', children: [_jsx("div", { className: 'title', children: "NLP Service Env" }), _jsx(DropDown_NlpEnv, { editable: this.state.editable, prop: 'env', onSelected: async (env) => {
                        if (env) {
                            await this.state.editable.update('env', env);
                            storageKey_preferredEnv.set(env);
                        }
                    } })] });
    };
    renderContentBuilder = () => {
        return _jsxs(LL_V_L, { className: 'composer-body', children: [this.renderTagMultiselect(), this.renderEnvDropDown(), this.renderFreeTextInput(), this.renderFindings()] });
    };
    renderStructuredView() {
        return _jsxs(LL_H_C, { className: 'nlp-message-composer', children: [this.renderContentBuilder(), this.renderVariablePanel()] });
    }
}
//# sourceMappingURL=Component_NLPRequestMessageComposer.js.map